import { render, staticRenderFns } from "./uploader.vue?vue&type=template&id=25c7356a&scoped=true&"
import script from "./uploader.vue?vue&type=script&lang=ts&"
export * from "./uploader.vue?vue&type=script&lang=ts&"
import style0 from "./uploader.vue?vue&type=style&index=0&id=25c7356a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c7356a",
  null
  
)

export default component.exports